import { useEffect } from "react";

import { useCart } from "@shopify/hydrogen-react";
import { type CartLine } from "@shopify/hydrogen-react/storefront-api-types";

import { useLegacyCart } from "@cart/LegacyCartContext";
import { checkIfNonEditableProductVendor } from "@tablescape/utilities";

export const useAutoRemoveOnwardProduct = (
  relevantCartLineChanging: boolean
) => {
  const { lines, linesRemove } = useCart();
  const { updateToLegacyCart } = useLegacyCart();

  useEffect(() => {
    if (!relevantCartLineChanging && lines.length > 0) {
      const onwardLines = lines
        .filter((line): line is CartLine =>
          checkIfNonEditableProductVendor(
            line?.merchandise?.product?.vendor ?? ""
          )
        )
        .map(({ id }) => id);

      if (onwardLines.length === 0 || onwardLines.length < lines.length) {
        return;
      }

      try {
        linesRemove(onwardLines);
        updateToLegacyCart({
          updates: onwardLines.map((id) => ({ id, quantity: 0 })),
        });
      } catch (error) {
        console.error("Error removing Onward products from cart:", error);
      }
    }
  }, [lines, linesRemove, relevantCartLineChanging, updateToLegacyCart]);
};
